

import { useState } from "react"
import { KTIcon } from "../../../../../_metronic/helpers"
const TimePickerModal = ({ onClose, clockIn, setClockIn }) => {
    const [hours, setHours] = useState(clockIn?.split(':')[0]);
    const [minutes, setMinutes] = useState(clockIn?.split(':')[1]);

    return (
        <>
            <div
                className='modal fade show d-block'
                id='kt_modal_add_user'
                role='dialog'
                tabIndex={-1}
                aria-modal='true'
            >
                <div className={`modal-dialog modal-dialog-centered mw-550px`}>
                    <div className='modal-content'>
                        <div className='modal-header py-3'>
                            <h2 className='fw-bolder mb-0'>Select Time</h2>
                            <div
                                className='btn btn-icon btn-sm btn-active-icon-primary'
                                data-kt-users-modal-action='close'
                                onClick={onClose}
                                style={{ cursor: 'pointer' }}
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>

                        </div>
                        <div className={`modal-body scroll-y mx-5  mx-xl-5 my-2 py-4`}>
                            <div className="row">
                                <div className="col-6">
                                    <label className="fw-bold fs-6 mb-2">Hour</label>
                                    <select className="form-select form-select-solid fw-bolder"
                                        value={hours}
                                        onChange={(e) => setHours(e.target.value)}
                                    >
                                        {
                                            hoursList.map((hour, index) => {
                                                return (
                                                    <option key={index} value={hour.value}>
                                                        {hour.text}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-6">
                                    <label className="fw-bold fs-6 mb-2">Minute</label>
                                    <select className="form-select form-select-solid fw-bolder"
                                        value={minutes}
                                        onChange={(e) => setMinutes(e.target.value)}
                                    >
                                        {
                                            minutesList.map((minute, index) => {
                                                return (
                                                    <option key={index} value={minute.value}>
                                                        {minute.text}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="text-center pt-10">
                                <button
                                    onClick={onClose}
                                    className="btn btn-light me-3"
                                >
                                    Discard
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-main text-white"
                                    disabled={!hours || !minutes}
                                    onClick={() => {
                                        setClockIn(hours + ':' + minutes + ':00')
                                        onClose()
                                    }}
                                        
                                >
                                    <span className="indicator-label">Confirm</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    )
}

export { TimePickerModal }

export const hoursList = [
  { text: '12 AM', value: '00' },
  { text: '01 AM', value: '01' },
  { text: '02 AM', value: '02' },
  { text: '03 AM', value: '03' },
  { text: '04 AM', value: '04' },
  { text: '05 AM', value: '05' },
  { text: '06 AM', value: '06' },
  { text: '07 AM', value: '07' },
  { text: '08 AM', value: '08' },
  { text: '09 AM', value: '09' },
  { text: '10 AM', value: '10' },
  { text: '11 AM', value: '11' },
  { text: '12 PM', value: '12' },
  { text: '01 PM', value: '13' },
  { text: '02 PM', value: '14' },
  { text: '03 PM', value: '15' },
  { text: '04 PM', value: '16' },
  { text: '05 PM', value: '17' },
  { text: '06 PM', value: '18' },
  { text: '07 PM', value: '19' },
  { text: '08 PM', value: '20' },
  { text: '09 PM', value: '21' },
  { text: '10 PM', value: '22' },
  { text: '11 PM', value: '23' },
]

export const minutesList = [
  { text: "00", value: '00' },
  { text: "15", value: '15' },
  { text: "30", value: '30' },
  { text: "45", value: '45' }
];